/*! (c) Andrea Giammarchi - ISC */
// https://github.com/WebReflection/talk2gpt/blob/main/js/listen.js

let {Object, Promise, SpeechRecognition, clearTimeout, setTimeout} = globalThis;
if (!SpeechRecognition) {
  try {
    SpeechRecognition = webkitSpeechRecognition;
  } catch (e) {
    console.warn("SpeechRecognition is not supported in this browser:", e.message);
  }
}

const {assign} = Object;
const interimResults = {interimResults: true};
const once = {once: true};

export default (options = void 0) => new Promise((resolve, reject) => { // eslint-disable-line import/no-anonymous-default-export
  let t = 0, ended = false;
  const stop = event => {
    clearTimeout(t);
    ended = true;
    sr.stop();
    if (event) {
      if (event.type === 'nomatch' || event.error === 'no-speech')
        resolve('');
      else
        reject(event.type === 'end' ? {error: 'unable to understand'} : event);
    }
  };
  const result = ({results}) => {
    stop();
    for (const result of results) {
      if (result.isFinal) {
        for (const {transcript} of result) {
          resolve(transcript);
          return;
        }
      }
    }
  };
  const sr = assign(new SpeechRecognition, options, interimResults); // eslint-disable-line new-parens
  sr.addEventListener('error', stop, once);
  sr.addEventListener('nomatch', stop, once);
  sr.addEventListener('end', stop, once);
  sr.addEventListener('audioend', () => stop(), once);
  sr.addEventListener('result', event => {
    if (ended)
      result(event);
    else {
      clearTimeout(t);
      t = setTimeout(result, 750, event);
    }
  });
  sr.start();
});

// listen to something
// listen().then(
//   transcript => {
//     log('You said: ' + (transcript || 'nothing'));
//   },
//   console.error
// );